import React, { useEffect } from "react";
import svg44 from "../../../assets/svg/svg44.svg";
import svg70 from "../../../assets/svg/svg70.svg";
import svg71 from "../../../assets/svg/svg71.svg";
import svg72 from "../../../assets/svg/svg72.svg";
import svg73 from "../../../assets/svg/svg73.svg";
import svg74 from "../../../assets/svg/svg74.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeaveBals } from "../../../features/dropdown/dropdownSlice";

const items = [
  {
    title: "Annual Leave",
    days: "05",
    balance: "07",
    svg: svg73,
    balanceBgColor: "#EDF2F4",
    balanceColor: "#3B7080",
  },
  {
    title: "Medical Leave",
    days: "11",
    balance: "07",
    svg: svg72,
    balanceBgColor: "#D6E9FF",
    balanceColor: "#1B84FF",
  },
  {
    title: "Casual Leave",
    days: "02",
    balance: "10",
    svg: svg71,
    balanceBgColor: "#F7EEF9",
    balanceColor: "#AB47BC",
  },
  {
    title: "Other Leave",
    days: "02",
    balance: "10",
    svg: svg74,
    balanceBgColor: "#FFEDF6",
    balanceColor: "#FD3995",
  },
];
function Cards() {
  const dispatch =  useDispatch()
  const {leaveBals } = useSelector((state)=>state.dropdown)

  const svgMap = {
    svg73, 
    svg74, 
    svg71, 
    svg72, 
  };
  const processedData = leaveBals?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));

  async function fetchLeaveBalsData(){
    await dispatch(fetchLeaveBals())
  }

  useEffect(()=>{
    fetchLeaveBalsData()
  },[])
  console.log("leaveBals",leaveBals)
  return (
    <div className="mt-[2.5rem] flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
      {processedData &&
        processedData?.map((item) => (
          <div
          style={{background:item?.balanceBgColor}}
            className={`leave-card p-[1.25rem] lg:w-[350px] w-full h-[120px]`}
          >
            <img
              src={item?.svg}
              alt="icon"
              className="absolute top-8 right-9 w-8 h-8 opacity-50"
            />
            <p>{item?.title}</p>
            <h4 className="font-[600] text-[18px] mt-[.25rem]">{item?.days}</h4>
            <span class="py-[.25rem] rounded-[4px] px-[.45rem] font-[600] bg-[#EDF2F4] text-[#3B7080] bg-secondary-transparent">
              Remaining Leaves :{item?.balance}
            </span>
          </div>
        ))}
    </div>
  );
}

export default Cards;
